import { render, staticRenderFns } from "./ClientePendiente.vue?vue&type=template&id=db863bbc&"
import script from "@/Servicios/ClientePendiente.js?vue&type=script&lang=js&"
export * from "@/Servicios/ClientePendiente.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports